<!-- Silence is gold!  -->
<router-outlet></router-outlet>
<div  id="overlay" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
<app-loader-emitter (loaderEventEmitter)="updateLoadingStatus($event)"></app-loader-emitter>
